// externals
import type { Reducer } from 'redux';
import type { Draft } from 'immer';
import { produce } from 'immer';

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { DocMoveState } from '@makemydeal/dr-dash-types';

// consts/enums
import { DOC_MOVE_WS_EVENT, DOC_MOVE_CLEAR_ALERT } from '../actionTypes/docMoveActionTypes';
import { CREDIT_APP_SEARCH_MERGE_DEAL } from '../actionTypes/creditAppSearchActionTypes';

export const docMoveInitialState: DocMoveState = {
    wsEvent: null
};

export type DocMoveReducer = Reducer<DocMoveState>;

export const reducer: DocMoveReducer = (state: DocMoveState = docMoveInitialState, action: AnyFSA) => {
    return produce(state, (draft: Draft<DocMoveState>) => {
        switch (action?.type) {
            case DOC_MOVE_WS_EVENT:
                draft.wsEvent = action.payload?.data || null;
                break;

            case DOC_MOVE_CLEAR_ALERT:
            case CREDIT_APP_SEARCH_MERGE_DEAL:
                draft.wsEvent = null;
                break;

            default:
                break;
        }
    });
};
